import React, { useMemo } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import DataTable from "react-data-table-component";
import "assets/css/dataTable.css";

const ContainerResultadosCheckDocsBDS3FechaDesdeHasta = ({
  filter,
  columns,
  handleOnChangeFilterResultados,
  actionsMemo,
  fixedHeader,
  paginationComponentOptions,
  tableData,
}) => {
  const stats = useMemo(() => {
    if (!Array.isArray(tableData) || tableData.length === 0) {
      return { empresas: 0, registros: 0, folios: 0 };
    }
    const isPlaceholder = tableData.length === 1 && tableData[0]?.rut === 'SIN REGISTROS';
    if (isPlaceholder) {
      return { empresas: 0, registros: 0, folios: 0 };
    }
    const empresas = new Set();
    let folios = 0;
    tableData.forEach((r) => {
      if (r.rut) empresas.add(r.rut);
      const n = Number(r.total);
      if (Number.isFinite(n)) folios += n;
    });
    return { empresas: empresas.size, registros: tableData.length, folios };
  }, [tableData]);

  return (
    <Container fluid className="page-container">
      <Row className="stats-row">
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--info">
            <div className="stat-card__icon"><i className="nc-icon nc-paper-2" /></div>
            <div className="stat-card__content">
              <span className="stat-card__label">Empresas con diferencias</span>
              <span className="stat-card__value">{stats.empresas}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--warning">
            <div className="stat-card__icon"><i className="nc-icon nc-bullet-list-67" /></div>
            <div className="stat-card__content">
              <span className="stat-card__label">Registros</span>
              <span className="stat-card__value">{stats.registros}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--danger">
            <div className="stat-card__icon"><i className="nc-icon nc-simple-remove" /></div>
            <div className="stat-card__content">
              <span className="stat-card__label">Folios faltantes en BD</span>
              <span className="stat-card__value">{stats.folios}</span>
            </div>
          </div>
        </Col>
      </Row>

      <Card className="data-card">
        <Card.Body>
          <div className="data-card__toolbar">
            <div className="search-input">
              <i className="nc-icon nc-zoom-split" />
              <input
                type="text"
                name="search"
                value={filter}
                autoComplete="off"
                placeholder="Filtrar por empresa, rut, fecha..."
                onChange={handleOnChangeFilterResultados}
              />
            </div>
            <Button className="btn-export" onClick={actionsMemo.onExport}>
              <i className="nc-icon nc-cloud-download-93" />
              Exportar CSV
            </Button>
          </div>
          <DataTable
            className="-striped -highlight"
            fixedHeader={fixedHeader}
            columns={columns}
            data={tableData}
            pagination
            paginationComponentOptions={paginationComponentOptions}
          />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContainerResultadosCheckDocsBDS3FechaDesdeHasta;
